import { Link } from 'react-router-dom';
import Social from '../../data/social';
import logo2 from "../../assets/img/logo-2.png";

const SideBar = ({ isOpen, setIsOpen }) => {
    return (
        <>
            <div className={`header__area-menubar-right-sidebar-popup ${isOpen ? 'active' : ''}`}>
                <div className="sidebar-close-btn" onClick={() => setIsOpen(false)}><i className="fal fa-times"></i></div>
                <div className="header__area-menubar-right-sidebar-popup-logo d-flex justify-content-center">
                <Link to='/'>
                    <img src={logo2} alt="logo" />
                </Link>
                </div>
                <p style={{color: '#000'}}>Redefining the construction industry with innovative solutions, cuttin-edge technology and sustainable practices</p>
                <div className="header__area-menubar-right-sidebar-popup-contact">
                    <h4 className="mb-30 text-center">İletişim</h4>
                    <div className="header__area-menubar-right-sidebar-popup-contact-item">
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-icon">
                            <i className="flaticon-phone"></i>
                        </div>
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-content">
                            <span>Telefon</span>
                            <h6><Link to="tel:+123 (256) 568 58">+123 (256) 568 58</Link></h6>
                        </div>
                    </div>
                    <div className="header__area-menubar-right-sidebar-popup-contact-item">
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-icon">
                            <i className="flaticon-email-3"></i>
                        </div>
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-content">
                            <span>E-Posta</span>
                            <h6><Link to="mailto:needhelp@gmail.com">needhelp@gmail.com</Link></h6>
                        </div>
                    </div>
                    <div className="header__area-menubar-right-sidebar-popup-contact-item">
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-icon">
                            <i className="flaticon-location-1"></i>
                        </div>
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-content">
                            <span>Adres</span>
                            <h6><Link to="https://google.com/maps" target="_blank">2464 Royal sLn. Mesa, New Jersey 45463</Link></h6>
                        </div>
                    </div>
                </div>
                <div className="header__area-menubar-right-sidebar-popup-social d-flex justify-content-center">
                    <Social />							
                </div>
            </div>
            <div className={`sidebar-overlay ${isOpen ? 'show' : ''}`}></div>
        </>
    );
};

export default SideBar;